"use strict";

var _regeneratorRuntime = require("/codebuild/output/src532132034/src/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _lodash = _interopRequireDefault(require("lodash.get"));

var _clientAwsS = require("@devsta/client-aws-s3");

var _memoizeOne = _interopRequireDefault(require("memoize-one"));

var _getErrorType = _interopRequireDefault(require("./getErrorType"));

var _constants = require("../constants");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
  try {
    var info = gen[key](arg);
    var value = info.value;
  } catch (error) {
    reject(error);
    return;
  }

  if (info.done) {
    resolve(value);
  } else {
    Promise.resolve(value).then(_next, _throw);
  }
}

function _asyncToGenerator(fn) {
  return function () {
    var self = this,
        args = arguments;
    return new Promise(function (resolve, reject) {
      var gen = fn.apply(self, args);

      function _next(value) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
      }

      function _throw(err) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
      }

      _next(undefined);
    });
  };
}

function getData(data, error) {
  if (error) {
    var _error$graphQLErrors$ = error.graphQLErrors[0].extensions.exception,
        _organisation = _error$graphQLErrors$.organisation,
        _userEmail = _error$graphQLErrors$.userEmail;
    return {
      organisation: _organisation,
      userEmail: _userEmail
    };
  }

  var organisation = (0, _lodash.default)(data, 'getOrganisationInvite.organisation', {});

  var _get2 = (0, _lodash.default)(data, 'getOrganisationInvite.user', {}),
      _get2$email = _get2.email,
      userEmail = _get2$email === void 0 ? '' : _get2$email;

  return {
    organisation: organisation,
    userEmail: userEmail
  };
}

var addImageToOrganisation = (0, _memoizeOne.default)(function (apolloClient, tempAuthToken) {
  return (/*#__PURE__*/function () {
      var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(_ref2) {
        var data, error, errorType, _getData, organisation, userEmail, organisationWithImage;

        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                data = _ref2.data, error = _ref2.error;
                errorType = (0, _getErrorType.default)(error);

                if (!(error && errorType !== _constants.existingOrgMember)) {
                  _context.next = 4;
                  break;
                }

                return _context.abrupt("return", {});

              case 4:
                _getData = getData(data, error), organisation = _getData.organisation, userEmail = _getData.userEmail;
                _context.next = 7;
                return (0, _clientAwsS.replaceBucketKeysWithUrls)({
                  apiClient: apolloClient,
                  data: organisation,
                  substitutedKeys: ['imageUrl', {
                    key: 'defaultUser',
                    subKeys: ['imageUrl']
                  }],
                  tempAuthToken: tempAuthToken,
                  organisationId: organisation.organisationId
                });

              case 7:
                organisationWithImage = _context.sent;
                return _context.abrupt("return", {
                  organisationWithImage: organisationWithImage,
                  userEmail: userEmail
                });

              case 9:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }));

      return function (_x) {
        return _ref.apply(this, arguments);
      };
    }()
  );
});
var _default = addImageToOrganisation;
exports.default = _default;